<template>
  <div id="CheckOption">
    <div class="topic_title">{{listData.order}}.( {{typetext}} ){{listData.questionTitle}}</div>
    <div class="img_url" v-if="img_url">
      <img :src="img_url" />
    </div>
    <div class="topic_box">
      <el-checkbox-group  @change="getVal" v-model="radio">
        <p :key="index" class="option" v-for="(item, index) in listData.questionSelect">
          <el-checkbox :label="item.value">{{item.lable}}</el-checkbox>
        </p>
      </el-checkbox-group>
    </div>

    <div class="el-Parsing" v-if="showStatus === true">
      <div class="eye_box" v-if="!is_mode">
        <div class="eye_btn" @click="contrast">
          查看答案
        </div>
      </div>
      <div class="eye_box" v-if="is_mode">
        <div class="eye_btn" @click="upBank">
          收起答案
        </div>
      </div>
      <div class="title" v-if="is_mode">
        <div class="title_item">
          参考答案：<span class="blue"> {{listData.questionAnswer  | check_text}}</span>
        </div>
        <div class="title_item">
          你的答案：<span class="red">{{listData.select | check}}</span>
        </div>
      </div>
      <template v-if="is_mode" >
        <div class="content" v-if="listData.questionDescribe">
          答案解析：{{listData.questionDescribe}}
        </div>
      </template>
    </div>

  </div>
</template>
<script>
module.exports = {
  name: 'check-option',
  props: ['bankdata', 'typetext','showStatus'],
  data () {
    return {
      listData: '',
      radio: [],
      img_url: '',
      is_mode: false
    }
  },
  computed: {},
  created () {

    this.initData()
  },
    watch: {
    bankdata () {
      this.is_mode=false
      this.radio =[]
      this.initData()
    }
  },
  filters: {
    check (val) {
      if (val instanceof Array) {
        return val.toString().replace(/,/g, '、')
      } else if (val) {
        if (val.indexOf('###') > -1) {
          return val.replace(/###/g, '、')
        } else {
          return val
        }
      }
    },
    check_text (val) {
      if (val.indexOf('###') > -1) {
        return val.replace(/###/g, '、')
      } else {
        return val
      }
    }
  },

  methods: {

    contrast(){
       this.is_mode = !this.is_mode
    },
    upBank(){
      this.is_mode = !this.is_mode
    },
    redios (val) {
         const array = []
      if (val.length  > 1) {
        if( val.indexOf('###') > -1 ) {
          const split= val.split('###') 
          return split
        }else{
          for(let i = 0 ; i<val.length ;i ++){
           array .push(val[i])
          }
        return array
        }
      } else{
        array .push(val)
        return array
      }
    },


    getVal () {
      console.log('多选择',this.radio)
      let obj = {
        examinationItemId: this.listData.examinationItemId,
        select: this.radio
      }
      this.$emit('getchildval', obj)
    },
    initData () {
      let arr = this.bankdata.questionSelect
      if (this.bankdata.img) {
        this.img_url = sessionStorage.getItem("base_url") + this.bankdata.img
      } else {
        this.img_url = ""
      }
      if (!(arr instanceof Array)) {
        console.log(1111)
        arr = arr.split('###')
        let obj = []
        for (let i = 0; i < arr.length; i++) {
          obj[i] = {}
          obj[i].lable = arr[i]
          obj[i].value = arr[i].substring(0, 1)
        }
        this.bankdata.questionSelect = obj
      }
      this.listData = this.bankdata
      if (this.listData.select) {
        this.radio = this.redios(this.listData.select) 
      }
    }
  }
}
</script> 
<style>
.eye_btn{
  margin:10px;
  cursor: pointer;
}
  .option{
    margin-top: 1.375rem;
    width: 100%;
    margin-bottom: 1.375rem;
    display: flex;
    align-items: flex-start;
  }
  .title {
  display: flex;
  font-size: 1rem;
}
.title_item {
  display: inline-flex;
  align-items: center;
}
.content {
  color: #222;
  font-size: 0.875rem;
  line-height: 1.375rem;
  margin: 1.25rem 0;
}
</style>
